// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import clsx from "clsx";

// const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
//   const { t } = useTranslation();

//   return (
//     <div
//       className={clsx(
//         sidebarMenu
//           ? "sidebar-menu"
//           : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
//       )}
//     >
//       <nav>
//         <ul>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/"}>{t("home")}</Link>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/about"}>{t("About Us")}</Link>
//           </li>
//           {/* <li>
//              <Link to={process.env.PUBLIC_URL + "/"}>
//               {t("Western Wear")}
//             </Link>
//           </li> */}
//           {/* <li> */}
//             {/* <Link to={`${process.env.PUBLIC_URL}/Collections?category=Kurta`}>
//           {t("Everday Elegance")}
//         </Link> */}
//           {/* </li> */}
//           {/* <li>
//              <Link to={process.env.PUBLIC_URL + "/Collections"}>
//               {t("Western Wear")}
//             </Link>
//           </li> */}
//            <li>
//             <Link
//               to={`${process.env.PUBLIC_URL}/Collections?category=Suits`}
//             >
//               {t("Suits")}
//             </Link>
//           </li>
//           <li>
//             <Link
//               to={`${process.env.PUBLIC_URL}/Collections?category=westernwear`}
//             >
//               {t("Western Wear")}
//             </Link>
//           </li>
//            <li>
//             <Link
//               to={`${process.env.PUBLIC_URL}/Collections?category=Coordset`}
//             >
//               {t("Coord Set")}
//             </Link>
//           </li>

//           {/* <li>
//             <Link to={process.env.PUBLIC_URL + "/"}>
//               {t("Western Wear")}
//               {sidebarMenu ? (
//                 <span>
//                   <i className="fa fa-angle-right"></i>
//                 </span>
//               ) : (
//                 <i className="fa fa-angle-down" />
//               )}
//             </Link>
//             <ul className="submenu">
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/cart"}>
//                   {t("Coorsets")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/checkout"}>
//                   {t("Coordsets")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/wishlist"}>
//                   {t("Dresses")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/compare"}>
//                   {t("Skirts & Tops")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/my-account"}>
//                   {t("Jumpsuits")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/login-register"}>
//                   {t("Shorts")}
//                 </Link>

//               </li>
//             </ul>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/contact"}>
//               {t("Loungewear")}
//             </Link>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/contact"}>
//               {t("Athleisure")}
//             </Link>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/contact"}>
//               {t("Kidswear")}
//             </Link>
//           </li> */}
//           {/* <li>
//             <Link to={process.env.PUBLIC_URL + "/blog-standard"}>
//               {t("blog")}
//               {sidebarMenu ? (
//                 <span>
//                   <i className="fa fa-angle-right"></i>
//                 </span>
//               ) : (
//                 <i className="fa fa-angle-down" />
//               )}
//             </Link>
//             <ul className="submenu">
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/blog-standard"}>
//                   {t("blog_standard")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/blog-no-sidebar"}>
//                   {t("blog_no_sidebar")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/blog-right-sidebar"}>
//                   {t("blog_right_sidebar")}
//                 </Link>
//               </li>
//               <li>
//                 <Link to={process.env.PUBLIC_URL + "/blog-details-standard"}>
//                   {t("blog_details_standard")}
//                 </Link>
//               </li>
//             </ul>
//           </li> */}
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/contact"}>
//               {t("Contact Us")}
//             </Link>
//           </li>
//         </ul>
//       </nav>
//     </div>
//   );
// };

// NavMenu.propTypes = {
//   menuWhiteClass: PropTypes.string,
//   sidebarMenu: PropTypes.bool,
// };

// export default NavMenu;

// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import clsx from "clsx";

// const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
//   const { t } = useTranslation();

//   return (
//     <div
//       className={clsx(
//         sidebarMenu
//           ? "sidebar-menu"
//           : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
//       )}
//     >
//       <nav>
//         <ul>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/"}>{t("home")}</Link>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/about"}>{t("About Us")}</Link>
//           </li>
//           <li>
//             <Link to={`${process.env.PUBLIC_URL}/Collections?category=Suits`}>
//               {t("Suits")}
//             </Link>
//           </li>
//           <li>
//             <Link
//               to={`${process.env.PUBLIC_URL}/Collections?category=westernwear`}
//             >
//               {t("Western Wear")}
//             </Link>
//           </li>
//           <li>
//             <Link
//               to={`${process.env.PUBLIC_URL}/Collections?category=Coordset`}
//             >
//               {t("Coord Set")}
//             </Link>
//           </li>
//           <li>
//             <Link to={process.env.PUBLIC_URL + "/contact"}>
//               {t("Contact Us")}
//             </Link>
//           </li>
//         </ul>
//       </nav>
//     </div>
//   );
// };

// NavMenu.propTypes = {
//   menuWhiteClass: PropTypes.string,
//   sidebarMenu: PropTypes.bool,
// };

// export default NavMenu;


// import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";
// import clsx from "clsx";
// import { useNavigate } from "react-router-dom";

// const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   const handleCategoryClick = (categoryname) => {
//     navigate("/Collections", {
//       state: { categoryname },
//     });
//   };

//   return (
//     <div
//       className={clsx(
//         sidebarMenu
//           ? "sidebar-menu"
//           : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
//       )}
//     >
//       <nav>
//         <ul>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => navigate("/")}
//             >
//               {t("home")}
//             </span>
//           </li>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => navigate("/about")}
//             >
//               {t("About Us")}
//             </span>
//           </li>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => handleCategoryClick("Suits")}
//             >
//               {t("Suits")}
//             </span>
//           </li>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => handleCategoryClick("westernwear")}
//             >
//               {t("Western Wear")}
//             </span>
//           </li>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => handleCategoryClick("Coordset")}
//             >
//               {t("Coord Set")}
//             </span>
//           </li>
//           <li>
//             <span
//               className="cursor-pointer"
//               onClick={() => navigate("/contact")}
//             >
//               {t("Contact Us")}
//             </span>
//           </li>
//         </ul>
//       </nav>
//     </div>
//   );
// };

// NavMenu.propTypes = {
//   menuWhiteClass: PropTypes.string,
//   sidebarMenu: PropTypes.bool,
// };

// export default NavMenu;


//main

// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import clsx from "clsx";

// const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
//   const { t } = useTranslation();

//   return (
//     <div
//       className={clsx(
//         sidebarMenu
//           ? "sidebar-menu"
//           : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
//       )}
//     >
//       <nav>
//         <ul>
//           <li>
//             <Link to="/">{t("home")}</Link>
//           </li>

//           <li>
//             <Link to="/about">{t("About Us")}</Link>
//           </li>

//           <li>
//             <Link
//               to={{
//                 pathname: "/Collections",
//               }}
//               state={{ categoryname: "Suits" }}
//             >
//               {t("Suits")}
//             </Link>
//           </li>

//           <li>
//             <Link
//               to={{
//                 pathname: "/Collections",
//               }}
//               state={{ categoryname: "westernwear" }}
//             >
//               {t("Western Wear")}
//             </Link>
//           </li>

//           <li>
//             <Link
//               to={{
//                 pathname: "/Collections",
//               }}
//               state={{ categoryname: "Coordset" }}
//             >
//               {t("Coord Set")}
//             </Link>
//           </li>

//           <li>
//             <Link to="/contact">{t("Contact Us")}</Link>
//           </li>
//         </ul>
//       </nav>
//     </div>
//   );
// };

// NavMenu.propTypes = {
//   menuWhiteClass: PropTypes.string,
//   sidebarMenu: PropTypes.bool,
// };

// export default NavMenu;
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        sidebarMenu
          ? "sidebar-menu"
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
      )}
    >
      <nav>
        <ul>
          <li>
            <Link to="/">{t("home")}</Link>
          </li>
          <li>
            <Link to="/about">{t("About Us")}</Link>
          </li>
          <li>
            <Link to="/Collections?categories=Suits">
              {t("Suits")}
            </Link>
          </li>
          <li>
            <Link to="/Collections?categories=westernwear">
              {t("Western Wear")}
            </Link>
          </li>
          <li>
            <Link to="/Collections?categories=Coordset">
              {t("Coord Set")}
            </Link>
          </li>
          <li>
            <Link to="/contact">{t("Contact Us")}</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;